import { Epar, TimeToPrice } from '~/Api/Analytics/VirtualBrand/TimeToPrice';

import ActionTypes from './ActionTypes';

export interface TimeToPriceState {
	request: Promise<any>;
	isFething: boolean;
	epar: Epar | null;
	prices: TimeToPrice[] | null;
}

export interface State {
	byId: { [key: string]: TimeToPriceState };
}

type Action =
	| {
			type: ActionTypes.request;
			request: Promise<any>;
			id: string;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			id: string;
			epar: Epar;
			prices: TimeToPrice[];
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			id: string;
			epar: null;
			prices: null;
	  }
	| {
			type: ActionTypes.pruneAll;
	  };

function createState(): State {
	return {
		byId: {},
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				byId: {
					...state.byId,
					[action.id]: {
						request: action.request,
						isFething: true,
						epar: null,
						prices: null,
					},
				},
			};

		case ActionTypes.receive: {
			const timeToPriceState = state.byId[action.id];
			if (timeToPriceState.request !== action.request) {
				return state;
			}
			if (!action.prices) {
				const byId = { ...state.byId };
				delete byId[action.id];
				return { ...state, byId };
			}

			return {
				...state,
				byId: {
					...state.byId,
					[action.id]: {
						...timeToPriceState,
						isFething: false,
						epar: action.epar,
						prices: action.prices,
					},
				},
			};
		}

		case ActionTypes.pruneAll:
			return createState();

		default:
			return state;
	}
}

export function selectTimeToPriceById(state: State, id: string): TimeToPriceState | null {
	return state.byId[id] || null;
}
